// A big export is prepared by a background job (backend appdata/export_job.py, enterprise-scale WP-14.3): ask for it, then poll until the
// person's own link is ready. The server answers `409 async_export_required` from the synchronous route when a result is over its row limit.
export async function runAsyncExport(apiFetch, apiErrorFrom, jobRoute, query, { onWaiting, sleep = (ms) => new Promise((r) => setTimeout(r, ms)), maxMinutes = 20, everyMs = 3000 } = {}) {
  const started = await apiFetch(jobRoute, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(query) });
  const body = await started.json().catch(() => ({}));
  if (!started.ok) throw apiErrorFrom(started, body, 'Export failed');
  onWaiting?.();
  const deadline = Date.now() + maxMinutes * 60_000;
  while (Date.now() < deadline) {
    await sleep(everyMs);
    const r = await apiFetch(`/api/exports/${body.job_id}`, { method: 'GET' });
    const st = await r.json().catch(() => ({}));
    if (!r.ok) throw apiErrorFrom(r, st, 'Export failed');
    if (st.status === 'ready') return st;                     // { url, rows, truncated }
    if (st.status === 'failed' || st.status === 'lost' || st.status === 'expired') throw new Error(st.error || 'The export could not be made.');
  }
  throw new Error('The export is taking longer than usual. You will get a notification when it is ready.');
}
